import styled from 'styled-components'

export const Container = styled.div`
    /* padding: 20px; */
`
export const HeaderPaymentLinks = styled.div`
    /* padding: 15px 10px; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* padding: 14px 14px;
    padding-bottom: 0px; */
    /* min-width: 1000px; */
    padding: 0px 12px;
    /* background: #fff; */
    border-bottom: solid 1px #d3d3d3;
    h2 {
        font-family: 'Roboto';
        font-weight: 500;
        font-size: 20px;
    }

    ul {
        display: flex;
        gap: 20px;
        overflow-x: auto;

        li {
            font-family: 'Inter';
            font-size: 14px;
            font-weight: 400;
            text-align: center;
            white-space: nowrap;
            cursor: pointer;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                left: 0;
                bottom: 0;
                background: rgb(37, 99, 235);
                width: 0;
                height: 2px;
                display: flex;
                align-items: center;
                transition: width 0.5s;
                border-radius: 50px 50px 0px 0px;
            }

            &.active {
                &::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    background: rgb(37, 99, 235);
                    width: 100%;
                    height: 2px;
                    display: flex;
                    align-items: center;
                    transition: width 0.5s;
                    border-radius: 80px 80px 0px 0px;
                    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
                }
                /* border-bottom-style: solid; */
                /* border-bottom-color: rgb(37, 99, 235); */
                /* border-bottom-width: 2px; */

                &::before {
                    background: transparent;
                }
                /* background: rgb(37, 99, 235, 0.02); */
            }

            &:hover:not(.active) {
                &::before {
                    width: 100%;
                }
                /* background: rgb(37, 99, 235, 0.02); */
            }

            button {
                padding: 15px 14px;
                width: 100%;
                height: 100%;
                display: flex;
                gap: 5px;

                .to-approve-notification {
                    /* display: flex;
                    align-items: center;
                    justify-content: center;
                    
                    color: #fff;
                    background: #3fd97f;
                    border-radius: 20px;
                    font-family: 'Roboto';
                    font-weight: 500;
                    font-size: 12px;

                    
                    width: 20px;
                    height: 20px; */
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #3fd97f;
                    background: rgba(90, 219, 148, 0.3);
                    border-radius: 6px;
                    font-family: 'Roboto';
                    font-weight: 500;
                    font-size: 12px;

                    width: 20px;
                    height: 20px;
                }
            }

            &.active {
                button {
                    color: rgb(37, 99, 235);
                }
            }

            /* padding-bottom: 14px; */
        }
    }
    .button {
        background: #28a745;
    }
`
export const Content = styled.div`
    padding: 0 20px 20px 20px;
`
export const Title = styled.div`
    /* border-bottom: 1px solid #d3d3d3; */
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 30px;
    margin-bottom: 30px;

    h1 {
        margin-top: 10px;
        margin-bottom: 10px;
        color: #333;
        font-family: 'Inter';
        font-weight: 500;
        font-size: 20px;
    }
`

export const PaymentLinks = styled.div`
    border-radius: 10px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    background: #fff;
    margin-bottom: 40px;
    overflow: auto;
    ::-webkit-scrollbar {
        width: 2px;
        height: 6px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #333;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-track {
        background-color: #d3d3d3;
    }
`

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
`
